<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.compliancestakeholder" :id="id" :models="models" :infos="infos" topClass=""></show>

			<!-- Anagrafica / collegamento CRM -->
			<v-card v-if="stakeholder" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Anagrafica / collegamento CRM</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openCompany"><v-icon left small>mdi-domain</v-icon> Collega azienda</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<template v-if="stakeholder.company">
						<v-icon left small>mdi-domain</v-icon> {{ stakeholder.company }}
					</template>
					<span v-else class="grey--text">— nessuna azienda collegata —</span>
				</v-card-text>
			</v-card>

			<!-- Norme -->
			<v-card v-if="stakeholder" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openNorms"><v-icon left small>mdi-pencil</v-icon> Modifica</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<template v-if="stakeholder.norms && stakeholder.norms.length">
						<v-chip v-for="n in stakeholder.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>{{ n.text }}</v-chip>
					</template>
					<span v-else class="grey--text">— nessuna —</span>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="compliancestakeholder"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'compliancestakeholders-edit', id)" color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<v-dialog v-model="companyDialog" max-width="560" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Collega azienda</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="formCompany" :items="companyOptions" item-text="text" item-value="value"
							label="Azienda" outlined dense :menu-props="{'offset-y': true}" clearable prepend-icon="mdi-domain"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="companyDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="savingCompany" @click="saveCompany">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="normsDialog" max-width="560" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Norme applicabili</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="formNorms" :items="normOptions" item-text="text" item-value="value"
							label="Norme" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-certificate"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="normsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="savingNorms" @click="saveNorms">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceStakeholder',
	props: { id: Number },
	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			companyDialog: false,
			savingCompany: false,
			formCompany: null,
			companyOptions: [],
			normsDialog: false,
			savingNorms: false,
			formNorms: [],
			normOptions: []
		}
	},
	computed: {
		stakeholder() { return this.models.compliancestakeholder }
	},
	created() { this.load() },
	methods: {
		load() {
			this.loading = true
			this.axios.get('compliancestakeholders/' + this.id).then(r => {
				this.models = r.data.models
				this.infos = r.data.infos
				this.loading = false
			}, () => { this.loading = false; this.$store.commit('setSnackbarError') })
		},
		openCompany() {
			this.formCompany = this.stakeholder.company_id
			if (!this.companyOptions.length) this.axios.get('compliance-companies-options').then(r => { this.companyOptions = r.data.data })
			this.companyDialog = true
		},
		saveCompany() {
			this.savingCompany = true
			this.axios.put('compliancestakeholders/' + this.id, { company_id: this.formCompany }).then(() => {
				this.savingCompany = false; this.companyDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => { this.savingCompany = false; this.$store.commit('setSnackbarError') })
		},
		openNorms() {
			this.formNorms = (this.stakeholder.norms || []).map(n => n.value)
			if (!this.normOptions.length) this.axios.get('compliance-norms-options').then(r => { this.normOptions = r.data.data })
			this.normsDialog = true
		},
		saveNorms() {
			this.savingNorms = true
			this.axios.put('compliancestakeholders/' + this.id, { norms: this.formNorms }).then(() => {
				this.savingNorms = false; this.normsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => { this.savingNorms = false; this.$store.commit('setSnackbarError') })
		}
	}
}
</script>
